import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from "rxjs";
import { ApiService } from "./api.service";
import { CreatePickupRequestModel } from "../models/pickup-request.model";

@Injectable({
  providedIn: 'root'
})
export class PickupRequestService {
  private _apiService: ApiService = inject(ApiService);
  constructor() { }

  createPickupRequest(data: CreatePickupRequestModel): Observable<any> {
    return this._apiService.post('/end-consumers/me/pick-up-requests/', data);
  }

  searchDonateTo(query: string): Observable<any> {
    const PAGE_SIZE: number = 20;
    return this._apiService.get(`/end-consumers/me/donate-to-search/?page_size=${PAGE_SIZE}&query=${query}`).pipe(
      catchError(error => {
        return throwError(() => new Error(error.message || 'Failed to fetch donation data'));
      })
    );
  }
}
